// extracted by mini-css-extract-plugin
module.exports = {"zoomControlls":"styles_zoomControlls__xMrkP","zoomOutIcon":"styles_zoomOutIcon__2M7ya","zoomInIcon":"styles_zoomInIcon__3PJpT","percentage":"styles_percentage__31Axo"};